// ********** src/index.js ************
// Entry point da aplicação
// O Create React App procura por este arquivo
// ********** src/index.js ************

import React from 'react';
import ReactDOM from 'react-dom/client';
// import Rotas from './rotas';
import Rotas from './routes/rotas';
import { AuthProvider } from './app/Context/auth';
import "./Styles/global.css";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <AuthProvider>
            <Rotas />
        </AuthProvider>
    </React.StrictMode>
);
